export default function ProjectCard({
  href,
  imageSrc,
  imageAlt,
  title,
  description,
  techStack,
  animationDelay = "",
}) {
  return (
    <a
      href={href}
      target="_blank"
      className={`group relative overflow-hidden rounded-2xl bg-white/[0.02] border border-white/10 hover:border-[#f15700]/50 transition-all duration-300 animate__animated ${animationDelay}`}
      rel="noreferrer"
    >
      <div className="hidden md:block aspect-video overflow-hidden">
        <img
          src={imageSrc}
          alt={imageAlt}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 group-hover:opacity-60"
        />
      </div>
      
      <div className="p-6">
        <h2 className="text-xl font-bold text-white group-hover:text-[#f15700] transition-colors duration-300 mb-2">
          {title}
        </h2>
        
        <p className="text-sm text-gray-400 mb-4 line-clamp-2">
          {description}
        </p>
        
        <div className="pt-4 border-t border-white/10">
          <p className="text-xs text-gray-500 font-medium">
            <span className="text-gray-300">Tech Stack:</span> {techStack}
          </p>
        </div>
      </div>
      
      {/* Decorative hover glow */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#f15700]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
    </a>
  );
}
